import * as layoutActions from '../../layout/actions/layout.actions';
import { AppThunk } from '../../../store/rootReducer';
import { annotationTableSelector } from '../../auth/selectors/auth.selectors';
import { isRestingStripSelector } from '../../ecg/selectors/ecg.selectors';
import { ANNOTATION_TABLE_GROUPING } from '../../resting/resting.util';

export const setRestingLayout = (): AppThunk<void> => (dispatch, getState) => {
  const userAnnotationTable = annotationTableSelector(getState());
  const isRestingStrip = isRestingStripSelector(getState());
  const restingFeature =
    isRestingStrip &&
    !!userAnnotationTable &&
    ANNOTATION_TABLE_GROUPING[userAnnotationTable] != null;
  dispatch(
    layoutActions.update({
      update: {
        withDiagnosticGroup: restingFeature,
        withSuggestionsPanel: restingFeature,
        withComputedMetrics: restingFeature,
        withPatientInfo: restingFeature,
      },
    }),
  );
};
